import React, { useState, useEffect } from 'react';
import Layout from 'Component/Layouts/layout';
import {
  Box,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Modal,
  Card,
  CardContent,
  Grid,
} from '@mui/material';
import { Download, Group, CheckCircle, Schedule, HourglassEmpty } from '@mui/icons-material';
import TableComponent from 'Component/Table';
import useApiCaller from 'hooks/apiCaller';
import DownloadIcon from '@mui/icons-material/Download';
import * as XLSX from 'xlsx';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Reports = () => {
  const [allCourses, setAllCourses] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [detailsReport, setDetailsReport] = useState({
    completedCount: null,
    enrolledCount: null,
    inProgressCount: null,
    notStartedCount: null,
  });
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [count, setCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const now = dayjs();
  const [timeRange, setTimeRange] = useState({
    // month: now.format("MM"),
    // year: now.format("YYYY"),
    month: '',
    year: '',
  });

  const DropdownComponents = (
    <>
      <FormControl sx={{ minWidth: { xs: '100%', sm: 120 } }}>
        <InputLabel>Month</InputLabel>
        <Select
          label="Month"
          value={timeRange.month}
          onChange={(e) => setTimeRange((prev) => ({ ...prev, month: e.target.value }))}
        >
          {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
            <MenuItem key={month} value={String(month).padStart(2, '0')}>
              {new Date(2000, month - 1).toLocaleString('default', {
                month: 'long',
              })}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl sx={{ minWidth: { xs: '100%', sm: 120 } }}>
        <InputLabel>Year</InputLabel>
        <Select
          label="Year"
          value={timeRange.year}
          onChange={(e) => setTimeRange((prev) => ({ ...prev, year: e.target.value }))}
        >
          {Array.from({ length: 2 }, (_, i) => {
            const year = new Date().getFullYear() - i;
            return (
              <MenuItem key={year} value={String(year)}>
                {year}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </>
  );

  const columns = [
    { label: 'Employee Name', field: 'employeeName' },
    { label: 'Employee Code', field: 'employeeId' },
    { label: 'Department', field: 'departmentName' },
    { label: 'Training Status', field: 'trainingStatus' },
  ];

  const tableName = 'Report';
  const apiCaller = useApiCaller();

  const handleShowCourses = async () => {
    try {
      const response = await apiCaller.get('/super-user/getAllCourse');
      if (response) {
        setAllCourses(response?.data?.data?.courses);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleGetDetails = async () => {
    try {
      const response = await apiCaller.post('/super-user/getReports', {
        courseId: selectedId,
      });
      setDetailsReport(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetTableData = async () => {
    if (!selectedId) return;
    try {
      const response = await apiCaller.post('super-user/getReportList', {
        courseId: selectedId,
        page: page + 1,
        limit,
        timeRange,
      });
      setTableData(response?.data?.data);
      setCount(response?.data?.data?.[0]?.totalCount || 0);
    } catch (error) {
      console.log('Error fetching table data:', error);
    }
  };

  const handlePageChange = (newPage, newLimit) => {
    setPage(newPage);
    setLimit(newLimit);
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleDownloadReport = async () => {
    if (!selectedId || !selectedMonth || !selectedYear) return;
    try {
      const response = await apiCaller.post('/super-user/getEmployeeQuestionsAndAnswers', {
        courseId: selectedId,
        month: selectedMonth,
        year: selectedYear,
      });
      if (response.data.data.length === 0) {
        toast.error(`No data found`, {
          theme: 'colored',
        });
      } else {
        const worksheet = XLSX.utils.json_to_sheet(response.data.data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');
        XLSX.writeFile(
          workbook,
          `course-report-${selectedId}-${selectedMonth}-${selectedYear}.xlsx`
        );
      }
      handleCloseModal();
    } catch (error) {
      console.error('Error downloading report:', error);
    }
  };

  useEffect(() => {
    handleShowCourses();
  }, []);

  useEffect(() => {
    if (selectedId) handleGetDetails();
  }, [selectedId]);

  useEffect(() => {
    console.log('TTTTTTTTTTTTT');
    if (selectedId) handleGetTableData();
  }, [selectedId, page, limit, timeRange]);

  return (
    <Layout>
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
          p: { xs: 2, md: 3 },
        }}
      >
        {/* Professional Header */}
        <Box
          sx={{
            mb: 2,
            background: '#ffffff',
            borderRadius: '8px',
            p: 2,
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e2e8f0',
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
            gap={1}
          >
            <Box>
              <Typography
                variant="h5"
                fontWeight="600"
                sx={{
                  color: '#1e293b',
                  mb: 0.25,
                }}
              >
                Training Reports
              </Typography>
              <Typography variant="body2" sx={{ color: '#64748b', fontWeight: '400' }}>
                Generate and analyze comprehensive training reports
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Course Selection and Controls */}
        <Card
          sx={{
            background: '#ffffff',
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            mb: 3,
          }}
        >
          <CardContent sx={{ p: 2 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: { xs: 'stretch', sm: 'center' },
                flexDirection: { xs: 'column', sm: 'row' },
                gap: { xs: 2, sm: 3 },
                flexWrap: 'wrap',
                mb: 4,
              }}
            >
              {/* Course Selection */}
              <FormControl sx={{ minWidth: { xs: '100%', sm: 280 } }} size="medium">
                <InputLabel id="course-select-label">Select Course</InputLabel>
                <Select
                  labelId="course-select-label"
                  id="course-select"
                  label="Select Course"
                  value={selectedId}
                  onChange={(event) => {
                    setSelectedId(event.target.value);
                  }}
                  sx={{
                    borderRadius: '12px',
                    '& .MuiOutlinedInput-root': {
                      '&:hover fieldset': {
                        borderColor: '#3b82f6',
                      },
                    },
                  }}
                >
                  {allCourses.map((item) => (
                    <MenuItem key={item._id} value={item._id}>
                      {item.courseTitle}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {selectedId && (
                <Button
                  variant="contained"
                  startIcon={<Download />}
                  onClick={handleOpenModal}
                  sx={{
                    borderRadius: '12px',
                    background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                    px: 3,
                    py: 1.5,
                    fontWeight: '600',
                    textTransform: 'none',
                    boxShadow: '0 4px 14px 0 rgba(59, 130, 246, 0.3)',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%)',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 8px 25px 0 rgba(59, 130, 246, 0.4)',
                    },
                  }}
                >
                  Download Report
                </Button>
              )}
            </Box>

            {/* Statistics Cards */}
            <Grid container spacing={2}>
              {[
                {
                  label: 'Total Enrolled',
                  value: detailsReport.enrolledCount || 0,
                  icon: <Group fontSize="small" />,
                  color: '#3b82f6',
                  bg: '#eff6ff',
                },
                {
                  label: 'Completed',
                  value: detailsReport.completedCount || 0,
                  icon: <CheckCircle fontSize="small" />,
                  color: '#10b981',
                  bg: '#f0fdf4',
                },
                {
                  label: 'In Progress',
                  value: detailsReport.inProgressCount || 0,
                  icon: <HourglassEmpty fontSize="small" />,
                  color: '#8b5cf6',
                  bg: '#f5f3ff',
                },
                {
                  label: 'Not Started',
                  value: detailsReport.notCompleted || 0,
                  icon: <Schedule fontSize="small" />,
                  color: '#f59e0b',
                  bg: '#fffbeb',
                },
              ].map(({ label, value, icon, color, bg }) => (
                <Grid item xs={12} sm={6} md={3} key={label}>
                  <Card
                    sx={{
                      border: '1px solid #e2e8f0',
                      borderLeft: `4px solid ${color}`,
                      borderRadius: '8px',
                      boxShadow: 'none',
                    }}
                  >
                    <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                      <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                        <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 500 }}>
                          {label}
                        </Typography>
                        <Box sx={{ p: 0.75, borderRadius: '6px', background: bg, color }}>
                          {icon}
                        </Box>
                      </Box>
                      <Typography variant="h4" fontWeight="700" sx={{ color: '#1e293b' }}>
                        {value}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>

        {/* Table Section */}
        <Card
          sx={{
            background: '#ffffff',
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            mb: 3,
          }}
        >
          <CardContent sx={{ p: 2 }}>
            <TableComponent
              tableData={tableData}
              setTableData={setTableData}
              columns={columns}
              tableName={tableName}
              onPageChange={handlePageChange}
              count={count}
              selectedId={selectedId}
              enableLocalSearch={false}
              customComponent={DropdownComponents}
            />
          </CardContent>
        </Card>
      </Box>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="download-report-modal"
        aria-describedby="select-month-year-for-report"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: 'calc(100% - 32px)', sm: 400 },
            maxWidth: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: { xs: 3, sm: 4 },
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" component="h2" sx={{ mb: 3 }}>
            Select Month and Year
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
            <FormControl fullWidth>
              <InputLabel>Month</InputLabel>
              <Select
                value={selectedMonth}
                label="Month"
                onChange={(e) => setSelectedMonth(e.target.value)}
              >
                {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                  <MenuItem key={month} value={month}>
                    {new Date(2000, month - 1).toLocaleString('default', { month: 'long' })}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel>Year</InputLabel>
              <Select
                value={selectedYear}
                label="Year"
                onChange={(e) => setSelectedYear(e.target.value)}
              >
                {Array.from({ length: 2 }, (_, i) => new Date().getFullYear() - i).map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button onClick={handleCloseModal} variant="outlined">
              Cancel
            </Button>
            <Button
              onClick={handleDownloadReport}
              variant="contained"
              disabled={!selectedMonth || !selectedYear}
            >
              Download
            </Button>
          </Box>
        </Box>
      </Modal>
    </Layout>
  );
};

export default Reports;
